import { Key, Lock, Shield, Map, Zap, Crosshair, Heart, Cpu, KeyRound, Radio } from 'lucide-react';
import { GLOBAL_UI } from '@/config/missionContent';

const ICON_MAP = { Key, Lock, Shield, Map, Zap, Crosshair, Heart, Cpu, KeyRound, Radio };

const SLOTS = [
  { id: 'lab_keycard', label: 'Keycard' },
  { id: 'tactical_scope', label: 'Scope' },
  { id: 'vault_key', label: 'Vault Key' },
  { id: 'first_aid_kit', label: 'Med Kit' },
  { id: 'security_badge', label: 'Badge' },
  { id: 'access_chip', label: 'Chip' },
  { id: 'encrypted_map', label: 'Map' },
  { id: 'master_key', label: 'Master' },
  { id: 'power_cell', label: 'Power' },
  { id: 'signal_beacon', label: 'Beacon' },
];

export default function Inventory({ items }) {
  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col items-end gap-2" data-testid="inventory-panel">
      <div className="text-xs font-terminal tracking-[4px] text-green-700 uppercase">{GLOBAL_UI.inventory.title} {GLOBAL_UI.inventory.slotCount(items.length, 10)}</div>
      <div className="flex gap-1.5 flex-wrap justify-end" style={{ maxWidth: 300 }}>
        {SLOTS.map(slot => {
          const collected = items.find(i => i.id === slot.id);
          const IconComp = collected ? ICON_MAP[collected.icon] : null;
          return (
            <div
              key={slot.id}
              className={`inventory-slot ${collected ? 'filled' : ''}`}
              title={collected ? collected.name : slot.label}
              data-testid={`inventory-slot-${slot.id}`}
              style={{ width: 42, height: 42 }}
            >
              {IconComp ? (
                <IconComp size={18} className="text-green-400" style={{ filter: 'drop-shadow(0 0 4px rgba(0,255,65,0.4))' }} />
              ) : (
                <div className="w-1.5 h-1.5 rounded-full bg-green-900/30" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
